import { createMultiStyleConfigHelpers } from '@chakra-ui/styled-system';
import { rem } from '../../utils/utils';

const { defineMultiStyleConfig } = createMultiStyleConfigHelpers(['content', 'trigger']);

const Toggletip = defineMultiStyleConfig({
  baseStyle: {
    content: {
      maxWidth: rem(320),
      padding: '16',
    },
    link: {
      _hover: {
        color: 'purple.60',
        textDecoration: 'underline',
      },
      color: 'purple.70',
    },
  },
});

export default Toggletip;
